module.exports = __webpack_public_path__ + "img/tree-04-d-leaves.32ab8d3f.png";